import React from 'react';
import { ShoppingBag, Truck, Award, Users } from 'lucide-react';

const AboutUs = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="bg-green-600 text-white py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">About AV Mart Shamli</h1>
          <p className="text-xl text-green-100">Your trusted partner for fresh groceries delivered to your doorstep</p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12">
        {/* Our Story */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Our Story</h2>
          <div className="bg-white rounded-lg shadow-md p-8">
            <p className="text-gray-700 leading-relaxed mb-4">
              Founded in 2010, AV Mart Shamli was born from a simple idea: everyone deserves access to fresh, 
              quality products without the hassle of crowded stores and long queues. What started as a small 
              local delivery service online grocery platforms.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              We partner directly with local farmers, trusted suppliers, and quality brands to bring you the 
              freshest produce, pantry staples, and household essentials. Our commitment to quality, freshness, 
              and customer satisfaction drives everything we do.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Our team of dedicated professionals works round the clock to ensure your 
              groceries reach you fresh, on time, and with a smile.
            </p>
          </div>
        </section>

        {/* Our Values */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Our Values</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white rounded-lg shadow-md p-6 text-center">
              <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <ShoppingBag className="text-green-600" size={32} />
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Quality First</h3>
              <p className="text-gray-600">We handpick every product to ensure top quality and freshness</p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 text-center">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Truck className="text-blue-600" size={32} />
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Fast Delivery</h3>
              <p className="text-gray-600">Same-day delivery options to get your groceries when you need them</p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 text-center">
              <div className="bg-yellow-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Award className="text-yellow-600" size={32} />
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Best Prices</h3>
              <p className="text-gray-600">Competitive pricing with regular offers and discounts</p>
            </div>

            <div className="bg-white rounded-lg shadow-md p-6 text-center">
              <div className="bg-purple-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <Users className="text-purple-600" size={32} />
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Customer Care</h3>
              <p className="text-gray-600">24/7 support to assist you with any queries or concerns</p>
            </div>
          </div>
        </section>

        {/* Our Mission */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Our Mission</h2>
          <div className="bg-gradient-to-r from-green-500 to-green-600 text-white rounded-lg shadow-md p-8">
            <p className="text-lg leading-relaxed mb-4">
              To revolutionize the way India shops for groceries by providing a seamless, convenient, and 
              reliable online platform that saves time, ensures quality, and promotes healthy living.
            </p>
            <p className="text-lg leading-relaxed">
              We aim to support local farmers and suppliers while reducing food waste and promoting 
              sustainable practices in the grocery supply chain.
            </p>
          </div>
        </section>

        {/* Team Section */}
        <section>
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Why Choose Us?</h2>
          <div className="bg-white rounded-lg shadow-md p-8">
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <h3 className="text-xl font-semibold text-gray-800 mb-3">🌾 Fresh from Farm</h3>
                <p className="text-gray-700">Direct partnerships with farmers ensure farm-fresh produce</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-800 mb-3">🚚 Express Delivery</h3>
                <p className="text-gray-700">Quick delivery slots including same-day and scheduled options</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-800 mb-3">💰 Best Deals</h3>
                <p className="text-gray-700">Regular discounts, combo offers, and loyalty rewards</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-800 mb-3">🔒 Secure Payments</h3>
                <p className="text-gray-700">Multiple payment options with bank-grade security</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-800 mb-3">📱 Easy App</h3>
                <p className="text-gray-700">We are launching soon a User-friendly interface for hassle-free shopping</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-800 mb-3">♻️ Eco-Friendly</h3>
                <p className="text-gray-700">Minimal packaging and sustainable delivery practices</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AboutUs;
